function loadMoreFAQs(button) {
    if (button) {
        const category = button.dataset.category;
        const existingFAQIds = button.dataset.faqids;
        const accordionItemWrapper = $(button).siblings('.faq-accordion__items');
        const maxAdditionalitems = Number(button.dataset.maxadditionalitems);
        const page = Number($(button).data('page'));
        const pageSize = Number(button.dataset.pagesize);

        if (accordionItemWrapper && category && existingFAQIds) {
            $.ajax({
                url: '/FAQ/LoadMoreFAQs',
                method: 'GET',
                data: { categoryId: category, existingFAQIds: existingFAQIds, page: page},
                success: function (data) {
                    $(accordionItemWrapper).append(data);
                    let itemsLoaded = page * pageSize;
                    let nextPage = page + 1;
                    $(button).data('page', nextPage);

                    if (itemsLoaded >= maxAdditionalitems) {
                        $(button).hide();
                    }
                }
            });
        }
    }
}